import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    width: "100%",
    marginBottom: "5%",
  },
  error: {
    color: "red",
    marginBlock: 0,
  },
  root: {
    position: "relative",
    zIndex: 10,
    height: "92vh",
    display: "flex",
    alignItems: "center",
    marginBlock: 0,
    justifyContent: "center",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    right: 0,
    top: 0,
    margin: "10px",
  },
  card: {
    borderRadius: 16,
    width: "100%",
    padding: 20,
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.85em",
    marginTop: '0',
  },
  forgotPassword: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1em",
    marginBottom: "0.5em",
  },
  rectangleBG: {
    position: "absolute",
    height: "100%",
    width: "100%",
    display: "flex",
    zIndex: 0,
    overflow: "hidden",
    justifyContent: "center",
  },
  rectangle: {
    position: "relative",
    left: 100,
    height: "100%",
    width: "30%",
    minWidth: "300px",
    transform: "skew(-15deg)",
    backgroundColor: "#F0F7EE",
  },
  rectangleXs: {
    position: "relative",
    height: "100%",
    width: "30%",
    minWidth: "300px",
    transform: "skew(-15deg)",
    backgroundColor: "#F0F7EE",
  },
  noPadding: {
    paddingBlock: "0 !important",
  },
  noHeight: {
    height: 0,
  },
  version: {
    textAlign: "center",
    marginTop: "10px",
    fontSize: "12px",
    color: "#959595"
  }
}));

export default useStyles;
